<template>
  <div class="add-form">
    <div class="pagination-container">
      <el-button size="small"
                 @click="goAdd">
        新建权限组
      </el-button>

      <el-pagination class="pagination-right"
                     :current-page="query.page"
                     :page-sizes="[10, 20, 50, 100, 500, 1000]"
                     :page-size="query.per_page"
                     :pager-count="5"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="totalCount"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange" />
    </div>
    <el-table :data="list"
              style="width: 100%">
      <el-table-column prop="name"
                       label="权限组名" />
      <el-table-column prop="authorization"
                       label="权限类型" />
      <el-table-column prop="routers"
                       label="页面路由">
        <template slot-scope="scope">
          <pre>{{ scope.row.routers }}</pre>
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       width="100">
        <template slot-scope="scope">
          <!--<el-button @click="goDetail(scope.row)" type="text" size="small">查看</el-button>-->
          <el-button type="text"
                     size="small"
                     @click="goAdd(scope.row)">
            编辑
          </el-button>
          <el-button type="text"
                     size="small"
                     @click="onDelete(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { queryAuthGroup, deleteAuthGroup } from '@/api/admin';

export default {
  props: {
    params: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      pageRouter: 'list',
      query: {
        page: 1,
        per_page: 20,
      },
      form: {},
      list: null,
      totalCount: 0,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      let params = Object.assign({}, this.query);

      params = Object.keys(this.params || {}).reduce((t, c) => {
        if (this.params[c]) {
          t[c] = this.params[c];
        }
        return t;
      }, params);
      Object.keys(params).forEach((p) => {
        if (!params[p] && params[p] !== 0) {
          delete params[p];
        }
      });
      queryAuthGroup(params).then((res) => {
        this.list = res.data.groups;
        this.totalCount = res.data.total;
        // 如果分页条件大于总数了，再查询一次
        if (this.query.page > 1 && (this.query.page - 1) * this.query.per_page >= this.totalCount) {
          this.query.page -= 1;
          this.fetchData();
        }
      });
    },
    onSubmit() { },
    onDelete(item) {
      this.$confirm('此操作将永久删除该权限组, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deleteAuthGroup({ id: item.id }).then((res) => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            this.fetchData();
            this.$store.dispatch('GetInfo');
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    handleSizeChange(val) {
      this.query.page = 1;
      this.query.per_page = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.fetchData();
    },
    goAdd(item) {
      this.$emit('setRPQ', { r: 'add', p: item ? item.id : undefined });
    },
    goDetail(item) {
      this.$emit('setRPQ', { r: 'detail', p: item.id });
    },
  },
};
</script>
